import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import dayjs, { Dayjs } from 'dayjs';
import { Observable } from 'rxjs';
import { DATE_FORMAT } from '../models/constants/input.constants';
import { Transport } from '../models/transport.model';
import { IMyDate } from 'ng-uikit-pro-standard';
import { ApiProviderService } from './api-provider.service';
import { mapAsBody } from '../app/shared/util/request-util';
import { API_ENDPOINTS } from '../models/enums/endpoints.enum';

@Injectable({ providedIn: 'root' })
export class TransportDateService {
  private dateUrl = API_ENDPOINTS.DATE_URL;

  constructor(public apiProvider: ApiProviderService) {}

  getNextDayAvailable(fromDate: Dayjs, pickupZipCode: string, pickupCountry: string, offerId: number | undefined): Observable<string> {
    return this.apiProvider
      .publicGet<string>(this.dateUrl + '/next-available-day?pickupZipCode=' + pickupZipCode + '&pickupCountry=' + pickupCountry + '&offerId=' + offerId, {
        params: new HttpParams().set('fromDate', JSON.stringify(fromDate.format(DATE_FORMAT))),
      })
      .pipe(mapAsBody);
  }

  public getNextDeliveryDayAvailable(transport: Transport): Observable<string> {
    return this.apiProvider.publicPost<string>(this.dateUrl + '/next-available-delivery-day', transport.serialize()).pipe(mapAsBody);
  }

  public convertDateFromClient(transport: Transport): Transport {
    if (transport.pickupDate) {
      transport.pickupDate = dayjs(transport.pickupDate);
    }
    if (transport.deliveryDate) {
      transport.deliveryDate = dayjs(transport.deliveryDate);
    }
    if (transport.deliveryMaxDate) {
      transport.deliveryMaxDate = dayjs(transport.deliveryMaxDate);
    }
    return Object.assign({}, transport, {
      pickupDate: transport.pickupDate?.isValid() ? transport.pickupDate.format(DATE_FORMAT) : undefined,
      deliveryDate: transport.deliveryDate?.isValid() ? transport.deliveryDate.format(DATE_FORMAT) : undefined,
      deliveryMaxDate: transport.deliveryMaxDate?.isValid() ? transport.deliveryMaxDate.format(DATE_FORMAT) : undefined,
    });
  }

  toDatePickerOptions(minDate: Dayjs): { minDate: IMyDate; maxDate: IMyDate } {
    return {
      minDate: {
        year: minDate.year(),
        month: minDate.month() + 1 /* index 0 based */,
        day: minDate.date(),
      },
      maxDate: { year: minDate.year() + 1, month: 12, day: 31 },
    };
  }

  toDatePickerOptionsForUpdate(minDate: Dayjs): { minDate: IMyDate; maxDate: IMyDate } {
    return {
      minDate: {
        year: minDate.year(),
        month: minDate.month() + 1 /* index 0 based */,
        day: minDate.date(),
      },
      maxDate: { year: dayjs().year() + 1, month: 12, day: 31 },
    };
  }
}
